module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/scss/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/scss/fonts/glyphicons-halflings-regular.svg
// module chunks = styles